import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Tournament } from "@/graphql"

export const TournamentCasualInfo = ({
  tournament,
  className = "",
}: {
  tournament: Tournament
  className?: string
}) => {
  if (!tournament || tournament.isPresential || tournament.Store.levelId === 1) {
    return null
  }

  return (
    <Card
      className={`w-full border-l-4 border-yellow-500 bg-yellow-50 dark:bg-yellow-900/30 dark:border-yellow-600 ${className}`}
    >
      <CardHeader>
        <CardTitle className="text-yellow-800 dark:text-yellow-200 text-lg font-semibold">
          ⚠️ Este torneo no sumará puntaje al ranking
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-sm text-yellow-700 dark:text-yellow-300 leading-relaxed">
          La participación en este torneo será válida únicamente como experiencia de juego y
          registro de resultados, pero{" "}
          <span className="font-medium">
            no otorgará puntos oficiales al ranking competitivo de la temporada.
          </span>
        </p>

        <div>
          <p className="font-medium text-yellow-800 dark:text-yellow-200 mb-2">
            Esto se debe a alguno de estos puntos:
          </p>
          <ul className="list-disc list-inside space-y-1 text-sm text-yellow-700 dark:text-yellow-300">
            <li>
              <span className="font-semibold">Juego remoto:</span> partidas realizadas en línea que
              no forman parte de la temporada oficial.
            </li>
            <li>
              <span className="font-semibold">Juego casual:</span> instancias pensadas para
              practicar y divertirse, sin impacto en la clasificación.
            </li>
            <li>
              <span className="font-semibold">Eventos amistosos:</span> torneos organizados con
              fines recreativos o de comunidad. Pero no de tiendas oficiales activas en el Plan de
              Juego Organizado.
            </li>
          </ul>
        </div>

        <p className="text-sm italic text-yellow-800 dark:text-yellow-200">
          ✨ Aun así, te invitamos a disfrutar la competencia con la misma energía y entusiasmo,
          aunque los resultados no afecten tu posición en el ranking.
        </p>
      </CardContent>
    </Card>
  )
}
